
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.md?watch=parent';
    export const demoIndex = {
  ids: ["wordcloud-demo-common","wordcloud-demo-0"],
  getter: () => import(/* webpackChunkName: "meta__WordCloud" */'/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.md?type=demo')
};